import React from 'react';
import { useTranslation } from 'react-i18next';

import { Loader } from '@/src/features/_components/loader/Loader';
import { useInitialization } from '@/src/features/app/behaviours/useInitialization';
import { AppContentError } from '@/src/features/app/features/content/Content.error';
import { Router } from '@/src/features/app/features/content/features/Router';
import { WebsocketConnector } from '@/src/features/app/features/content/features/WebsocketConnector';
import { useUserConfigurationContext } from '@/src/features/app/store/userConfiguration/context';
import { UserConfigurationStatus } from '@/src/features/app/store/userConfiguration/store';

export function AppContent() {
  const { status } = useUserConfigurationContext();
  const { t } = useTranslation();

  useInitialization();

  if (status === UserConfigurationStatus.Loading) {
    return <Loader />;
  }

  if (status === UserConfigurationStatus.Error) {
    return <AppContentError />;
  }

  return (
    <>
      <title>{t('APP.TITLE')}</title>
      <meta name="description" content={t('APP.DESCRIPTION')} />

      <WebsocketConnector />
      <Router />
    </>
  );
}
